import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from "app/components/Input";
import { nameof } from "core/util/nameof";
import { Form, Formik } from "formik";
import { Validate } from "./FCSAlternateADIValidate";
import { useNavigate } from "react-router";
import { useFcsAlternateAdiMutation } from "generated/generated-models";
import { Alert, LoadingButton } from "@mui/lab";
const FCSAlternateADI = () => {
    const [createFCSAlternateADIDetails, { loading, error }] = useFcsAlternateAdiMutation();
    const initialValues = {
        bsb: "",
        accountNumber: "",
        consent: false,
    };
    const navigate = useNavigate();
    const handleSubmit = async (values) => {
        const result = await createFCSAlternateADIDetails({
            variables: {
                input: {
                    BSB: values.bsb,
                    AccountNumber: values.accountNumber,
                    Consent: values.consent,
                },
            },
        });
        if (result.data?.fCSAlternateADI?.Success)
            navigate("/confirmation");
    };
    return (_jsxs("div", { className: "container sub-wrap", children: [_jsx("h2", { children: "Alternate ADI details for Financial Claim" }), error != null && (_jsxs(Alert, { severity: "error", children: ["Error submitting bank details: ", error.message, " Please try again."] })), _jsx(Formik, { initialValues: initialValues, onSubmit: (values) => handleSubmit(values), validationSchema: () => Validate(), children: _jsxs(Form, { children: [_jsx(Input, { name: nameof("bsb"), type: "text", label: "BSB Number" }), _jsx(Input, { name: nameof("accountNumber"), type: "text", label: "Account Number" }), _jsx(Input, { name: nameof("consent"), type: "checkbox", label: "Do you consent to provide your alternate ADI payment information: - to APRA and the RBA; or - any other paying agent nominated by APRA for the purposes of Financial Claims Scheme?" }), _jsx(LoadingButton, { type: "submit", id: "submit", loading: loading, sx: { p: 1.5, mt: 1 }, variant: "contained", children: "Submit" })] }) })] }));
};
export { FCSAlternateADI };
